<template>
  <div id='timeline-embed' style="width: 100%; height: 90vh"></div>
</template>

<script>
// import * as TL from '@knight-lab/timelinejs/dist/js/timeline-min';
// import '@knight-lab/timelinejs/dist/css/timeline.css';
import { mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
export default {
  name:"TimelineHome",
  data() {
    return {
      timelineData: null
    }
  },
  mounted() {
    console.log(this.$route)
    this.$nextTick(() => {
      this.refreshRecords()
    })
  },
  methods: {
    ...mapActions("task", [
      "fetchAllTimelineTasksByProjectId",
      "updateTask",
      "updateTaskStatus",
      "searchTask",
    ]),

    async refreshRecords() {
  
      try {
        
         let res = await this.fetchAllTimelineTasksByProjectId(
          this.$route.params.id,
          true
        )
        if(res.length>0) {
          this.timelineData = {events: res, title: res[0]}

          let timeline = new TL.Timeline('timeline-embed',
            this.timelineData);
          }
        
        
      } catch (error) {
        
      }
     
    },
  }
}
</script>

<style>
.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container  {
  background: #069959;
}

.tl-timemarker .tl-timemarker-content-container  {
  background: #2dce89;
}

.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline {
  color:#fff
}

.tl-timemarker .tl-timemarker-content-container .tl-timemarker-content .tl-timemarker-text h2.tl-headline {
  color:#fff
}

</style>